var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import PlainButton from '../../components/plain-button';

import ClassificationBadge from './ClassificationBadge';
import messages from './messages';

var ClassificationProperty = function ClassificationProperty(_ref) {
    var openModal = _ref.openModal,
        tooltip = _ref.tooltip,
        value = _ref.value;

    if (!openModal && !value) {
        return null;
    }

    return React.createElement(
        React.Fragment,
        null,
        React.createElement(FormattedMessage, _extends({ tagName: 'dt' }, messages.classification)),
        React.createElement(
            'dd',
            null,
            value ? React.createElement(
                'div',
                { className: 'mbs' },
                React.createElement(ClassificationBadge, {
                    tooltip: tooltip,
                    tooltipPosition: 'middle-left',
                    value: value
                })
            ) : null,
            openModal ? React.createElement(
                PlainButton,
                { className: 'lnk', onClick: openModal },
                React.createElement(FormattedMessage, messages[value ? 'edit' : 'addClassification'])
            ) : null
        )
    );
};

ClassificationProperty.propTypes = {
    openModal: PropTypes.func,
    tooltip: PropTypes.string,
    value: PropTypes.string
};

export default ClassificationProperty;